import styles from "./DetalhesColetaProdutos.module.css";
import Container from "../../../components/components-ui/Container/Container";
import Button from "../../../components/components-ui/Button/Button";
import api from "../../../services/Api";
// import Loading from '../../../components/components-ui/Loading/Loading'
import { BlockScreenLoading } from "../../../components/BlockScreenLoading";

import convert from "../../../utils/imageFileResize";
import { Link } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, Fragment } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";

// import { toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'

function DetalhesColetaNaoTemOleo() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [infoDetalheColeta, setInfoDetalheColeta] = useState([]);
  // const [showLoading, setShowLoading] = useState(false)
  const [blockScreen, setBlockScren] = useState(false);

  const [idOcSub, setIdOcSub] = useState("");
  const [idOc, setIdOc] = useState("");
  const [observacaoNaoTemOleo, setObservacaoNaoTemOleo] = useState([]);

  const [images, setImages] = useState(null);
  const [previewPhotos, setPreviewPhotos] = useState([]);

  useEffect(() => {
    async function getDetalheColeta() {
      try {
        setBlockScren(true);

        const response = await api.post(
          `/motorista/roteirodetalhecoleta/${id}`,
        );
        setInfoDetalheColeta(response.data);
        // setIdColeta(response.data.id_oc)
        setIdOcSub(response.data.id_oc_sub);
        setIdOc(response.data.id_oc);
      } catch (err) {
        console.log(err);
      } finally {
        setBlockScren(false);
      }
    }

    getDetalheColeta();
  }, []);

  async function salvarColetaNaoTemOleo() {
    if (observacaoNaoTemOleo.length == 0) {
      return confirmAlert({
        message: "Informe  uma observação !!!",
        buttons: [
          {
            label: "Fechar",
          },
        ],
      });
    }

    if (observacaoNaoTemOleo.length <= 5) {
      return confirmAlert({
        message: "Detalhe melhor sua observação !!!",
        buttons: [
          {
            label: "Fechar",
          },
        ],
      });
    }

    const data = {
      observacao: observacaoNaoTemOleo,
      idLocal: infoDetalheColeta.IDlocal,
      idOc: infoDetalheColeta.id_oc,
      // idColeta: idOcSub,
    };

    console.log(data);

    setBlockScren(true);
    try {
      const response = await api.post(`/freguesia/naotemoleo`, data);
      if (response.data.error === 1) {
        return confirmAlert({
          message: "Erro ao salvar",
          buttons: [
            {
              label: "Fechar",
            },
          ],
        });
      }

      uploadImages(response.data.IDColeta);

      toast.success(response.data.msg || "Salvo com sucesso", {
        autoClose: 3000,
      });
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setBlockScren(false);
    }

    /// volta para a tela anterior
    navigate(`/local/listagem-de-coletas/${idOc}`);
  }

  function previewImg(ev) {
    if (ev.target.files) {
      const files = Array.from(ev.target.files);
      setImages(files);
      const urls = files.map((file) => URL.createObjectURL(file));
      setPreviewPhotos(urls);
      return;
    }
    setPreviewPhotos([]);
    setImages(null);
  }

  async function uploadImages(idColeta) {
    setBlockScren(true);

    console.log(images);

    const id_oc_sub = infoDetalheColeta?.id_oc_sub;
    const formData = new FormData();

    const convertedImages = await Promise.all(
      images.map(async (img) => {
        const converted = await convert({
          file: img,
          type: "jpeg",
        });

        return converted;
      }),
    );

    convertedImages.forEach((file) => {
      formData.append("images", file);
    });

    const response = await api
      .post(`/motoristauploadimagemcoleta/${idColeta}`, formData)
      .then((res) => {
        setBlockScren(false);
        if (res.data.error === 0) {
          setImages(null);
          toast.success(res.data.status, { autoClose: 2500 });
        }
      })
      .catch((error) => {
        setImages(null);
        setBlockScren(false);
        toast.error(
          "Algo de errado aconteceu ao fazer o upload da imagem! " + error,
        );
      });
  }

  return (
    <Container>
      <BlockScreenLoading loading display={blockScreen}>
        <strong> Carregando... </strong>
      </BlockScreenLoading>

      <div className={styles.content}>
        <div className={styles.btn_footer}>
          <Link
            to={`/local/detalhe-coleta/${id}`}
            className={styles.backButton}
          >
            <i className="fas fa-arrow-left"></i> Voltar
          </Link>
        </div>

        <Fragment>
          <h3>
            Informar que o fornecedor Não tem óleo
            {infoDetalheColeta?.id_coleta}
          </h3>
          <section className={styles.wrap_coleta}>
            {/* Listagem */}
            <ul>
              <li>
                <strong>Codigo</strong>: {infoDetalheColeta?.Codigo}
              </li>

              <li>
                <strong>Marca</strong>: {infoDetalheColeta?.nome_local}
              </li>
            </ul>
            <div className={styles.detalhe_coleta}>
              {/* Formulario */}
              <form onSubmit={(ev) => ev.preventDefault()}>
                <>
                  <textarea
                    placeholder="Observação"
                    value={observacaoNaoTemOleo}
                    onChange={(e) => setObservacaoNaoTemOleo(e.target.value)}
                    style={{ marginTop: 10 }}
                  />

                  <section className={styles.wrap_btn_coleta}>
                    <div className={styles.imgBtn}>
                      <label className={styles.labelForImg} htmlFor="selectImg">
                        <i className="fas fa-camera"></i>
                        Capturar Imagem
                      </label>
                      <input
                        id="selectImg"
                        className={styles.selectImg}
                        type="file"
                        onChange={(ev) => previewImg(ev)}
                        accept="image/*"
                        capture="environment"
                        multiple
                      />
                    </div>

                    <Button
                      color="tertiary"
                      title="Salvar Coleta Não Tem Óleo"
                      onClick={salvarColetaNaoTemOleo}
                    />
                  </section>
                </>

                {infoDetalheColeta?.bloqueado === 1 ? (
                  <span>
                    {/* <strong>Aviso de ocorrência: </strong> */}
                    {infoDetalheColeta?.descricao_ocorrencia}
                  </span>
                ) : null}
              </form>
            </div>

            {images && (
              <div className={styles.previewImg}>
                <section className={styles.wrap_coleta}>
                  {previewPhotos.map((photo) => (
                    <img key={photo} src={photo} alt="Preview" width="100%" />
                  ))}
                </section>
              </div>
            )}
          </section>
        </Fragment>
      </div>
    </Container>
  );
}

export default DetalhesColetaNaoTemOleo;
